export interface DocEnvelope {
    version: number;
    editor: 'plate';
    value: any[];
}

export function unwrapDocVersion(raw: any): { version: number; value: any[] } {
    if (Array.isArray(raw)) return { version: 1, value: raw };
    if (raw && typeof raw === 'object' && Array.isArray(raw.value)) {
        return { version: raw.version ?? 1, value: raw.value };
    }
    return { version: 1, value: [] };
}

// Load-only cleanup: strip empty <p>'s that carry listStyleType. These get
// persisted when (a) legacy Slate docs had spacer <li>'s, or (b) an earlier
// buggy normalizer lifted nested list items as siblings without filtering
// empties. They render as bullets with no text — visual noise.
//
// Runs once on load (NOT on every editor change) so an in-flight empty bullet
// the user just created via Enter inside a list is never touched. Recurses into
// table cells and column-group containers because lists can live inside those.
function isEmptyListStyleParagraph(node: any): boolean {
    if (!node || node.type !== 'p') return false;
    if (!node.listStyleType) return false;
    if (!Array.isArray(node.children)) return true;
    return node.children.every((c: any) => c && typeof c === 'object' && typeof c.text === 'string' && c.text.trim() === '');
}

function stripEmptyListBulletsDeep(nodes: any[]): any[] {
    if (!Array.isArray(nodes)) return nodes;
    const out: any[] = [];
    for (const node of nodes) {
        if (isEmptyListStyleParagraph(node)) continue; // drop
        if (node && typeof node === 'object' && Array.isArray(node.children)) {
            out.push({ ...node, children: stripEmptyListBulletsDeep(node.children) });
        } else {
            out.push(node);
        }
    }
    return out;
}

export function runMigrations(_version: number, value: any[]): any[] {
    return stripEmptyListBulletsDeep(value);
}
